<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.3504 4.25H7.05039C6.67909 4.25 6.32299 4.3975 6.06044 4.66005C5.79789 4.9226 5.65039 5.2787 5.65039 5.65V13.35C5.65039 13.7213 5.79789 14.0774 6.06044 14.3399C6.32299 14.6025 6.67909 14.75 7.05039 14.75H13.3504C13.7217 14.75 14.0778 14.6025 14.3403 14.3399C14.6029 14.0774 14.7504 13.7213 14.7504 13.35V5.65C14.7504 5.2787 14.6029 4.9226 14.3403 4.66005C14.0778 4.3975 13.7217 4.25 13.3504 4.25Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
    <path d="M10.55 4.25V2.15C10.55 1.7787 10.4025 1.4226 10.1399 1.16005C9.8774 0.8975 9.5213 0.75 9.15 0.75H2.15C1.7787 0.75 1.4226 0.8975 1.16005 1.16005C0.8975 1.4226 0.75 1.7787 0.75 2.15V9.85C0.75 10.2213 0.8975 10.5774 1.16005 10.8399C1.4226 11.1025 1.7787 11.25 2.15 11.25H5.65" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconDocuments'
}
</script>
